import { useEffect } from "react";
import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

import { toastError } from "../../utils/toasts";
import { errorMessagesFromResponse } from "../../utils/errors";

export const useTriggerToastOnRTKError = (
  isError: boolean,
  error: FetchBaseQueryError | SerializedError | undefined
) => {
  useEffect(() => {
    if (isError) {
      const errList = errorMessagesFromResponse(error);
      errList.forEach((item) => {
        if (typeof item === "string") {
          toastError(`${item}`);
        }

        if (typeof item === "object") {
          toastError(`${Object.values(item).flat()}`);
        }
      });
    }
  }, [isError, error]);
};
